import { getTestOverrides } from '@wix/cli-test-overrides';
import originalPRetry from 'p-retry';

export interface RetryOptions {
  retries: number;
}

export default async function pRetry<T>(
  input: (attemptCount: number) => PromiseLike<T> | T,
  { retries }: RetryOptions
): Promise<T> {
  const { minRetryTimeout, retries: retriesOverride } = getTestOverrides();

  return originalPRetry(input, {
    retries: retriesOverride ?? retries,
    minTimeout: minRetryTimeout,
    maxTimeout: 3 * 1000,
  });
}
